module.exports = __webpack_public_path__ + "825501fd112391d6910c47b364ecfd71.svg";